import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-school-app-student',
  templateUrl: './school-app-student.component.html',
  styleUrls: ['./school-app-student.component.css']
})
export class SchoolAppStudentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
